import { useNavigation } from "../../hooks/useNavigation";
import { useEffect } from "react";

export const NotFound: React.FC = () => {
  const { navigateToTopPage } = useNavigation();

  useEffect(() => {
    navigateToTopPage();
  }, []);

  return (
    <div>
      <p>Not Found</p>
    </div>
  );
};
